import { render, staticRenderFns } from "./FormDatosParcelas.vue?vue&type=template&id=494b94e3&scoped=true"
import script from "./FormDatosParcelas.vue?vue&type=script&lang=js"
export * from "./FormDatosParcelas.vue?vue&type=script&lang=js"
import style0 from "./FormDatosParcelas.vue?vue&type=style&index=0&id=494b94e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b94e3",
  null
  
)

export default component.exports